import React, { Component } from 'react';
import cn from 'classnames';
import { withTranslation } from 'react-i18next';
import styles from './Housing.scss';

class Housing extends Component {
  constructor(props) {
    super(props);

    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
  }

  handleMenuItemClick(section, prevSection) {
    const { handleFilters } = this.props;
    handleFilters({ section, prevSection });
  }

  render() {
    const { pavilions, pavilionsFlat, selectedSectionPath, t } = this.props;

    const pavilionsList = {};
    pavilions.forEach((pavilion) => {
      const { id, construction_finished, construction_ending, year_built } = pavilion;
      pavilionsList[id] = { id, construction_finished, construction_ending, year_built };
    });

    const items = [];
    pavilionsFlat.forEach((pavilion, pavilionIndex) => {
      const { sections } = pavilion;
      const isPavilionHasOnlyOneSection = sections.length === 1;

      if (sections) {
        sections.forEach((section, sectionIndex) => {
          const { construction_finished, construction_ending, year_built } = pavilionsList[pavilion.id];
          const readyClass = construction_finished ? 'Finished' : 'InProcess';
          const active = selectedSectionPath[0] === pavilionIndex && selectedSectionPath[1] === sectionIndex;
          items.push(
            <div
              key={section.id}
              className={cn(styles.HousingMenuItem, { [styles.HousingMenuActive]: active })}
              onClick={this.handleMenuItemClick.bind(undefined, [pavilionIndex, sectionIndex], selectedSectionPath)}
            >
              <i className={cn(styles.RadioIcon, { [styles.Active]: active })}><i></i></i>
              {`${t('components.building.filters.housing.pavilion')} ${pavilion.name}${isPavilionHasOnlyOneSection ? '' : `, ${t('components.building.filters.housing.section')} ${section.name}`}`}
              <div className={cn(styles.Status, styles[readyClass], { [styles.UnderConstr]: (year_built == 0) })}>
                {
                  construction_finished ?
                    t('components.building.filters.housing.finished') :
                      ((year_built === 0) ? t('components.building.filters.housing.inProgress') : (`${construction_ending} / ${year_built || ''}`))
                }
              </div>
            </div>
          );
        });
      }
    });

    return (
      <div className={styles.HousingMenu}>
        <div className={styles.HousingMenuTitle}>{t('components.building.filters.housing.finished')}</div>
        {items}
      </div>
    );
  }
}

export default withTranslation()(Housing);



// WEBPACK FOOTER //
// ./src/components/Building/Chess/Filters/Housing/Housing.js